import { checkNumber } from "./utils"

export interface IPage<T> {
    content?: T[],
    last: boolean,
    first: boolean,
    totalPages: number,
    totalElements: number,
    numberOfElements: number,
    sort?: any,
    size: number,
    number: number
}

export function emptyPage<T>(page?: Partial<IPage<T>>): IPage<T> {
    return {
        content: [],
        last: false,
        first: true,
        totalPages: 0,
        totalElements: 0,
        numberOfElements: 0,
        size: 0,
        number: 0,
        ...page
    }
}

export function mockPage<T>(content: T[], pageNumber = 0, pageSize = 10): IPage<T> {
    const totalPages = Math.ceil(content.length / pageSize)
    return {
        content: content.slice(pageNumber * pageSize, Math.min(((pageNumber * pageSize) + pageSize), content.length)),
        last: totalPages === (pageNumber - 1),
        first: pageNumber < 1,
        totalPages,
        totalElements: content?.length ?? 0,
        numberOfElements: pageSize,
        size: pageSize,
        number: pageNumber,
    }
}

export function setupPageParams(pageNumber: number, pageSize: number = 10) {
    return {
        pageNumber: Math.max(0, checkNumber(pageNumber, 0) -1 ).toString(),
        pageSize: Math.max(1, checkNumber(pageSize, 10)).toString()
    }
}
